import { PACKAGE_VERSION } from "./constants";
import { initProvider } from "./provider";
import { OTELOptions } from "./types";
import { log, setDebugMode, warn } from "./utils/logger";
import { ViewRootSpanManager } from "./view";

export class Rum {
  private isInited: boolean = false;
  constructor() {
    this.isInited = false;
  }

  public async init(options: OTELOptions) {
    const { debug, headers, endpoint, resourceAttributes, sampleRate, ...viewConfig } = options;

    const providerOptions = {
      headers,
      endpoint,
      resourceAttributes,
      sampleRate,
    };

    setDebugMode(!!debug);
    if (this.isInited) {
      warn("[L9RUM Browser SDK] is already inited");
      return false;
    }
    this.isInited = true;
    const provider = await initProvider(providerOptions);
    const viewManager = new ViewRootSpanManager(provider, viewConfig);
    viewManager.init();

    log(`[L9RUM Browser SDK] Initialized successfully (v${PACKAGE_VERSION})`);
  }
}
